import React from "react";
import { Footer, Blog, Features, Uses, Header } from "../../containers";
import { CTA, Brand, Navbar, WhatTaasa } from "../../components";
import Providers from "../../containers/providers/Providers";
import "../../App.css";
import "../../index.css";

function Homepage() {
  return (
    <div className="App">
      <Navbar />
      <Header />
      <Brand />
      <WhatTaasa />
      <Features />
      <Providers />
      <Uses />
      <CTA />
      <Blog />
      <Footer />
    </div>
  );
}

export default Homepage;
